module.exports = __webpack_public_path__ + "static/img/laranja-zero.eeee553.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/produtos/thumbs/laranja-zero.png
// module id = uBVT
// module chunks = 0